import type { ImagePost } from "@circle-react/types";

import {
  reactQueryPost,
  reactQueryPut,
} from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

export interface ImagePostApiResponse extends ImagePost {
  status: string;
}

interface CreateImagePostParams {
  payload: object;
  spaceId: number;
}

export const createImagePost = ({ spaceId, payload }: CreateImagePostParams) =>
  reactQueryPost<ImagePostApiResponse, object>(
    internalApi.imagePosts.create(spaceId),
    payload,
  );

interface UpdateImagePostParams {
  payload: object;
  postSlug: string;
  spaceId: number;
}

export const updateImagePost = ({
  spaceId,
  postSlug,
  payload,
}: UpdateImagePostParams) =>
  reactQueryPut<ImagePostApiResponse, object>(
    internalApi.imagePosts.update(spaceId, postSlug),
    payload,
  );

interface DuplicateImagePostPayload {
  post: {
    space_id: number;
    send_notifications: boolean;
  };
}

interface DuplicateImagePostParams {
  payload: DuplicateImagePostPayload;
  postSlug: string;
  spaceId: number;
}

export const duplicateImagePost = ({
  spaceId,
  postSlug,
  payload,
}: DuplicateImagePostParams) =>
  reactQueryPut<ImagePost, DuplicateImagePostPayload>(
    internalApi.imagePosts.duplicate(spaceId, postSlug),
    payload,
  );
